var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login_header"},[_c('div',{staticClass:"login_header_content"},[_c('div',[_c('img',{staticStyle:{"width":"188px","height":"45px"},attrs:{"src":require("@/assets/images/LOGO.png")}})])])])])
}]

export { render, staticRenderFns }